import { categories } from '@/mocks/manga';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const quickLinks = [
    { id: 'popular', label: '热门推荐' },
    { id: 'categories', label: '漫画分类' },
    { id: 'latest', label: '最新更新' },
    { id: 'features', label: '阅读体验' },
    { id: 'about', label: '关于我们' },
    { id: 'faq', label: '常见问题' },
  ];

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 font-heading text-2xl text-accent-400">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-moon-clear-fill text-lg"></i>
              </span>
              飞飞漫画网
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
              飞飞漫画网专注漫画在线阅读，以极速加载、翻页流畅、夜间模式护眼三大体验为核心，让你随时随地畅快看漫画。海量热门作品，无需登录，打开即看。
            </p>
            <div className="mt-5 flex items-center gap-3 text-sm text-foreground-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line"></i>
                <a href="mailto:hello@feifeimanga.cn" className="hover:text-accent-400 transition-colors">hello@feifeimanga.cn</a>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.id}>
                  <button
                    type="button"
                    onClick={() => scrollTo(l.id)}
                    className="cursor-pointer text-sm text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.name}>
                  <button
                    type="button"
                    onClick={() => scrollTo('categories')}
                    className="cursor-pointer text-sm text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {c.name}漫画
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 飞飞漫画网 FeifeiManga. 保留所有权利。
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <a href="#" className="hover:text-accent-400 transition-colors">阅读条款</a>
            <a href="#" className="hover:text-accent-400 transition-colors">隐私政策</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('faq'); }} className="hover:text-accent-400 transition-colors">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}